export default __webpack_public_path__ + "static/media/11-Top-Programming-Trends-To-Look-For-In-20172.78b461cc.jpg";